var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconProfile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "44px",
    height: "29px",
    viewBox: "29 31 35 29",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 42.5086 45 C 46.0026 45 49 41.9021 49 37.9069 C 49 33.9625 45.9855 31 42.5086 31 C 39.0145 31 36 34.0302 36 37.9407 C 36 41.9021 38.9974 45 42.5086 45 Z M 52.5445 60 C 55.1023 60 56 59.2542 56 57.8305 C 56 53.6949 50.8168 48 42.5 48 C 34.2001 48 29 53.6949 29 57.8305 C 29 59.2542 29.8977 60 32.4555 60 L 52.5445 60 Z M 64 37 L 52 37 L 52 34 L 64 34 Z M 64 42 L 52 42 L 52 39 L 64 39 Z M 61 47 L 52 47 L 52 44 L 61 44 Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfile);
export default __webpack_public_path__ + "static/media/icon_profile.f8568ceb.svg";
export { ForwardRef as ReactComponent };